<template>
  <div
    class="modal fade"
    id="retiro"
    tabindex="-1"
    role="dialog"
    aria-labelledby="retiro"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-body text-center modal-contenido">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h3>Zonas de retiro en tienda</h3>
          <p>Seleccione su tienda mas cercana para verificar su disponibilidad.</p>

          <div class="row">
            <div class="col-sm-6">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="thead-gris">
                    <tr>
                      <th scope="col">Tienda y ubicación</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in inStorePickupOptions" :key="item.id_delivery">
                      <td
                        :style="
                          selectedDelivery == item.delivery_place
                            ? 'background-color: cadetblue;'
                            : ''
                        "
                      >
                        <span v-html="item.delivery_place"> </span>
                      </td>
                      <td>
                        <a href="#" @click="selectDeliveryOptions(item)"
                          ><small>Seleccionar</small></a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row" style="text-align: left;">
                <div class="col-sm-12" v-if="deliveryDay != ''">
                  <h5><i class="fa fa-archive"></i> Fecha Estimada:</h5>
                  <p style="text-align: left;">
                    Puedes retirar tu pedido a partir del {{ deliveryDay | esDate }}
                  </p>
                </div>
                <div class="col-sm-12" v-if="deliveryDay != ''">
                  <h5><i class="fa fa-calendar-times-o"></i> Hora de Atención en tienda:</h5>
                  <p style="text-align: left;"><span v-html="storeSchedule"></span></p>
                </div>
                <div class="col-sm-12">
                  <h5><i class="fa fa-usd"></i> Costo del servicio:</h5>
                  <p style="text-align: left;">Gratuito</p>
                </div>
                <div class="col-sm-12">
                  <h5><i class="fa fa-envelope-o"></i> Notificación:</h5>
                  <p style="text-align: left;">
                    Te enviaremos un correo electrónico cuando el producto este listo para ser
                    despachado.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              Seleccionar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { config_settings } from '@/config.js';
import { getDeliverysOptionsInStore } from '@/service/delivery.service.js';

export default {
  name: 'StoreWithdrawal',
  props: ['selectedDelivery', 'deliveryDay', 'storeSchedule'],
  data() {
    return {
      inStorePickupOptions: [],
    };
  },
  methods: {
    getInStorePickupOptions() {
      getDeliverysOptionsInStore()
        .then((response) => {
          this.inStorePickupOptions = response.data;
        })
        .catch((error) => {});
    },

    selectDeliveryOptions(item) {
      this.$parent.selectDelivery(
        item.id_delivery,
        'Retiro en tienda',
        item.delivery_place,
        item.delivery_cost,
        item.delivery_date,
        item.delivery_schedule,
      );
    },
  },
  created() {
    this.getInStorePickupOptions();
  },
};
</script>
